import { render, staticRenderFns } from "./TableListRequests.vue?vue&type=template&id=59492e24&"
import script from "./TableListRequests.vue?vue&type=script&lang=js&"
export * from "./TableListRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports